import { render, staticRenderFns } from "./AngularDelegator.vue?vue&type=template&id=998d05c8&scoped=true"
import script from "./AngularDelegator.vue?vue&type=script&lang=js"
export * from "./AngularDelegator.vue?vue&type=script&lang=js"
import style0 from "./AngularDelegator.vue?vue&type=style&index=0&id=998d05c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998d05c8",
  null
  
)

export default component.exports